// @flow

import * as React from 'react';

import { Ban, Check, LoaderCircle, TriangleAlert } from 'lucide-react';

import { IconContainer } from './IconContainer';
import type { AvailabilityIconName } from './IconContainer';

import styles from './Icon.scss';

const svgComponent = {
  available: Check,
  error: Ban,
  fail: Ban,
  lang_required: TriangleAlert,
  loading: LoaderCircle,
  ok: Check,
  unavailable: Ban,
  unknown: Ban,
  warning: TriangleAlert,
} as const;

type Props = {
  iconName: AvailabilityIconName,
  className?: string,
};

export function Icon({ iconName, className }: Props): React.MixedElement {
  const Svg = svgComponent[iconName];

  return (
    <IconContainer className={className} iconName={iconName}>
      <Svg aria-hidden="true" className={styles.svg} />
    </IconContainer>
  );
}
